import type { Lang } from '@shared/types';
import { useState } from 'preact/hooks';
import { t } from '../i18n/ru';
import { useController } from '../state/context';
import { Modal } from './Modal';

export function SettingsModal() {
  const c = useController();
  const [lang, setLang] = useState<Lang>(c.lang.value);
  const close = () => c.closeModal();
  return (
    <Modal labelId="settings-title" onClose={close}>
      <h2 id="settings-title">{t.settings.title}</h2>
      <label for="lang">{t.settings.lang}</label>
      <select id="lang" value={lang} onChange={(e) => setLang((e.target as HTMLSelectElement).value as Lang)}>
        <option value="ru">Русский</option>
        <option value="en">English</option>
      </select>
      <div class="note">{c.settingsNote.value}</div>
      <div class="btns">
        <button type="button" class="primary" onClick={() => void c.saveLang(lang)}>
          {t.settings.save}
        </button>
        <button type="button" onClick={close}>
          {t.settings.close}
        </button>
      </div>
    </Modal>
  );
}
